<template>
  <div class="p-8 bg-white border-b border-b-gray-200">
    <div class="flex grow items-center justify-between">
      <h1 class="text-gray-900 text-xl font-medium">
        {{ t("admin.settings.organisation.buildings") }}
      </h1>
      <primary-button
        :label="t('admin.settings.organisation.add_building')"
        :icon="PlusIcon"
        v-if="props.canCreateLocation"
        @click="isAddingBuilding = true"
      />
    </div>
    <add-building :open="isAddingBuilding" @close="isAddingBuilding = false" />
  </div>
</template>

<script setup>
import { PlusIcon } from "@heroicons/vue/20/solid";
import PrimaryButton from "@/Tailwind/Components/Buttons/PrimaryButton";
import { defineProps, ref } from "vue";
import AddBuilding from "@/Tailwind/Components/AddBuilding.vue";

import { useI18n } from "vue-i18n";
const { t } = useI18n();

let isAddingBuilding = ref(false);

const props = defineProps({
  canCreateLocation: Boolean,
});
</script>
